import {SimulationCalculationOptionValue, SimulationResultContract} from "../../../models/TradeSimulationRecords";
import {SimulationTrade} from "../../../models/SimulationTrade";
import {SimulationCalculationResult} from "../../../models/SimulationCalculationResult";

export class SimulationTradeDetail {

    private constructor(public readonly trade: SimulationTrade,
                        public readonly hasError: boolean = false,
                        public readonly contract?: SimulationResultContract,
                        public readonly value?: SimulationCalculationOptionValue) {
    }

    public hasValue(): boolean {
        return this.value != null;
    }

    public hasExpired(expiry: string): boolean {
        if (this.contract == null) {
            return false;
        }
        return this.contract.expiry.localeCompare(expiry) < 0;
    }

    public static create(asAt: string,
                         trade: SimulationTrade,
                         result: SimulationCalculationResult | null): SimulationTradeDetail {
        if (result == null) {
            return new SimulationTradeDetail(trade);
        } else {
            const maybeContract = result.contractFor(trade.code, trade.date);
            if (maybeContract.isEmpty()) {
                return new SimulationTradeDetail(trade, true);
            }
            const contract = maybeContract.get();
            return result.optionValuesForDate(asAt)
                         .map((vals) => vals.find(ov => (ov.code === trade.code) && (ov.tradeDate === trade.date)))
                         .map((optVal) => new SimulationTradeDetail(trade, false, contract, optVal))
                         .orElseGet(() => new SimulationTradeDetail(trade, false, contract));
        }
    }
}
